export default "__VITE_ASSET__CQR0FAFB__"